import React from "react";
import { Switch } from "antd";
import "./customswitch.styles.css";

const CustomSwitch = (props) => {
  return <Switch checked={props.checked} onChange={props.onChange} />;
};

export default CustomSwitch;
